import MainImg from '../styles/images/img-mainbackground-0.svg';
import MainMenu0 from '../styles/images/img-mainmenu-0.svg';
import MainMenu1 from '../styles/images/img-mainmenu-1.svg';
import MainMenu2 from '../styles/images/img-mainmenu-2.svg';
import MainMenu3 from '../styles/images/img-mainmenu-3.svg';
import MainMenu4 from '../styles/images/img-mainmenu-4.svg';
import MainMenu5 from '../styles/images/img-mainmenu-5.svg';
import { useRecoilState } from 'recoil';
import globalState from 'ui/src/state/globalState';
import { useCallback, useEffect, useState } from 'react';
import env from '../config/env';
import UserApi from '../api/UserApi';
import ServiceModal from './ServiceModal';
import { FooterWrap } from 'layout';
import Cookies from 'js-cookie';
import { setLogout, setUserInfo } from 'ui/src/utils/SetUserInfo';

const SSOURL = `${env().SSO_URL}`;
const LOGINURL = '/login';
const refreshInterval = 10 * 60 * 1000; // 1 minute

// base64 → UTF-8 안전 디코딩 유틸 (URL-safe 및 패딩 보정, 이중 인코딩 대응)
const decodeBase64Utf8 = (raw: string) => {
  const b64 = /%[0-9A-Fa-f]{2}/.test(raw) ? decodeURIComponent(raw) : raw;
  const normalize = (s: string) => {
    let n = s.replace(/-/g, '+').replace(/_/g, '/');
    const pad = n.length % 4;
    if (pad === 2) n += '==';
    else if (pad === 3) n += '=';
    else if (pad === 1) n += '===';
    return n;
  };
  try {
    const bin = atob(normalize(b64));
    const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));

    return new TextDecoder('utf-8').decode(bytes);
  } catch {
    try {
      return decodeURIComponent(escape(atob(normalize(b64))));
    } catch {
      return raw;
    }
  }
};

function MainPage() {
  const envs = env();
  const [service, setService] = useState({
    home_path: envs.CLIENT_DNS,
    crop_path: envs.CROP_PATH,
    car_path: envs.CAR_PATH,
    forest_path: envs.FOREST_PATH,
    sea_path: envs.SEA_PATH,
    img_path: envs.IMAGE_PATH,
    pfm_path: envs.PLATFARM_PATH,
  });

  const [userState, setUserState] = useRecoilState(globalState);

  // 서비스 모달
  const [serviceId, setServiceId] = useState<string>(''); // -> ["CROPS","FORST","OCEAN","VEHICLE"]
  const [status, setStatus] = useState<string>(''); //->신청, 승인, 삭제, 거절
  const [modalIs, setModalIs] = useState<boolean>(false);

  //서비스 임시저장
  const [where, setWhere] = useState<string>(''); // -> ["CROPS","FORST","OCEAN"]

  const getTokenRefresh = async () => {
    try {
      // if (!userState.isLogin) return; -> 로그아웃하고 로그인되면 false 상태가 되어 getTokenRefresh가 호출되지 않음
      await UserApi.ValidateToken('/auth/refresh').then((response) => {
        // 사용자 정보가 있을때
        if (response.data.status === 'OK' && response.data.data) {
          //사용자 정보 담기
          setUserInfo(response.data.data, setUserState);
        }
      });
    } catch (e) {
      setLogout(setUserState);
      alert(e.response.data.message);
      // SSO 자동로그인 처리 window.location.href = SSOURL;
      window.location.href = LOGINURL;
    }
  };

  useEffect(() => {
    // 메인페이지 접근 시 자동으로 로그인 체크
    // 쿠키에 로그인 정보있는지 확인
    const getCookies = async () => {
      const error = Cookies.get('login_error', { domain: env().COOKIE_DOMAIN });
      if (error) {
        alert(decodeBase64Utf8(error));
        Cookies.remove('login_error', { domain: env().COOKIE_DOMAIN });
      } else {
        try {
          // 사용자 정보 가져오기 -> /auth/refresh 호출
          await UserApi.ValidateToken('/auth/user/info').then((response) => {
            // 사용자 정보가 있을때
            if (response.data.status === 'OK' && response.data.data) {
              //사용자 정보 담기
              setUserInfo(response.data.data, setUserState);
            }
          });
        } catch (e) {
          setLogout(setUserState);
          // alert(`new user info: ${e.response.data.message}`);
          // SSO 자동로그인 처리
          // window.location.href = SSOURL;
          window.location.href = LOGINURL;
        }
      }
    };

    getCookies();
  }, []);

  // useEffect(() => {
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     const now = Date.now();
  //     if (userState.isLogin && now - userState.loginTime >= refreshInterval) {
  //       console.log('keydown event detected, refreshing token...');
  //       getTokenRefresh();
  //     }
  //   };

  //   const handleMouseEvent = (e: MouseEvent) => {
  //     const now = Date.now();
  //     if (userState.isLogin && now - userState.loginTime >= refreshInterval) {
  //       console.log('Mouse event detected, refreshing token...');
  //       getTokenRefresh();
  //     }
  //   };

  //   const handleScrollEvent = (e: Event) => {
  //     const now = Date.now();
  //     if (userState.isLogin && now - userState.loginTime >= refreshInterval) {
  //       console.log('Scroll event detected, refreshing token...');
  //       getTokenRefresh();
  //     }
  //   };

  //   window.addEventListener('keydown', handleKeyDown);
  //   window.addEventListener('mouseleave', handleMouseEvent);
  //   window.addEventListener('mouseout', handleMouseEvent);
  //   window.addEventListener('mouseup', handleMouseEvent);
  //   window.addEventListener('scroll', handleScrollEvent);

  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //     window.removeEventListener('mouseleave', handleMouseEvent);
  //     window.removeEventListener('mouseout', handleMouseEvent);
  //     window.removeEventListener('mouseup', handleMouseEvent);
  //     window.removeEventListener('scroll', handleScrollEvent);
  //   };
  // }, [userState]);

  const closeServiceModal = () => {
    setModalIs(false);
  };

  const menuOnClickEvent = useCallback(
    async (menu: string, loginCheck?: boolean, uid?: string, services?: any, roles?: any, group_id?: any) => {
      if (userState.isLogin || loginCheck) {
        const transformedServices = {
          services: userState.stae,
          roles: userState.userService,
          group_id: userState.groupId,
        };
        const idd = uid ? uid : userState.UserInformation.userId;

        if (menu === 'CROPS') {
          if (transformedServices.services.CROPS === '승인') {
            const url = transformedServices.roles.CROPS ? `&user_role=${transformedServices.roles.CROPS}` : '';
            location.href = `${service.crop_path}?usrId=${idd}${url}`;
          } else {
            setServiceId('CROPS');
            setStatus(transformedServices.services.CROPS);
            setModalIs(true);
          }
        } else if (menu === 'FORST') {
          if (transformedServices.services.FORST === '승인') {
            const url = transformedServices.roles.FORST ? `&user_role=${transformedServices.roles.FORST}` : '';
            location.href = `${service.forest_path}?usrId=${idd}${url}`;
          } else {
            setServiceId('FORST');
            setStatus(transformedServices.services.FORST);
            setModalIs(true);
          }
        } else if (menu === 'OCEAN') {
          if (transformedServices.services.OCEAN === '승인') {
            const url = transformedServices.roles.OCEAN ? `&user_role=${transformedServices.roles.OCEAN}` : '';
            location.href = `${service.sea_path}?usrId=${idd}${url}`;
          } else {
            setServiceId('OCEAN');
            setStatus(transformedServices.services.OCEAN);
            setModalIs(true);
          }
        } else if (menu === 'VEHICLE') {
          if (transformedServices.services.VEHICLE === '승인') {
            let url = transformedServices.roles.VEHICLE ? `&user_role=${transformedServices.roles.VEHICLE}` : '';
            url += `&group_id=${transformedServices.group_id.VEHICLE}`;
            location.href = `${service.car_path}?usrId=${idd}${url}`;
          } else {
            setServiceId('VEHICLE');
            setStatus(transformedServices.services.VEHICLE);
            setModalIs(true);
          }
        }
      } else {
        //로그인이 안 되어있을 경우
        alert('service 로그인 정보가 만료되었습니다. 다시 로그인해주세요.');
        setWhere(menu);
        // setMain((prevState) => ({ ...prevState, loginModal: true }));
      }
    },
    [userState],
  );

  //서비스신청후 사용자정보 업데이트
  const fetchUserData = async () => {
    try {
      // 사용자 정보 가져오기 -> /auth/refresh 호출
      await UserApi.ValidateToken('/auth/user/info').then((response) => {
        // 사용자 정보가 있을때
        if (response.data.status === 'OK' && response.data.data) {
          //사용자 정보 담기
          setUserInfo(response.data.data, setUserState);
        }
      });
    } catch (e) {
      setLogout(setUserState);
      // alert(`new user info: ${e.response.data.message}`);
      // SSO 자동로그인 처리
      window.location.href = SSOURL;
    }
  };

  return (
    <>
      <div className="cWrap">
        <section className="cMain">
          <article className="mainTopArea">
            <div className="mainTopTxt">
              <div className="big">
                약 300만건의
                <br />
                영상자료를 활용한
                <br />
                <span>One-Stop AI 서비스</span>
              </div>
              <div className="small">
                위성/항공/드론영상 계층적 활용으로 효율적이고
                <br />
                광범위한 도시 모니터링 및 관리
              </div>
            </div>
            <div className="mainTopImg">
              <img
                src={MainImg}
                alt="메인 배경 이미지"
              />
            </div>
          </article>

          <article
            className="mainMenuArea"
            style={{ minHeight: '660px' }}
          >
            <ul className="mainMenuList">
              <li>
                {/* <li className="noaccess"> */}
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => menuOnClickEvent('CROPS')}
                >
                  <div
                    className={`mainMenuTit ${
                      userState.isLogin && userState.stae.CROPS !== '승인' ? 'background_gray' : ''
                    }`}
                  >
                    <img
                      src={MainMenu2}
                      alt="재배작물 관리 서비스"
                    />
                    <div>재배작물 관리 서비스</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>팜맵 기반의 재배 작물 자동 탐지</li>
                  <li>행정구역별 통계 정보 확인</li>
                  <li>재배면적 신고, 관리</li>
                </ul>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => menuOnClickEvent('FORST')}
                >
                  <div
                    className={`mainMenuTit ${
                      userState.isLogin && userState.stae.FORST !== '승인' ? 'background_gray' : ''
                    }`}
                  >
                    <img
                      src={MainMenu3}
                      alt="불법산림훼손 관리 서비스"
                    />
                    <div>불법산림훼손 관리 서비스</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>불법 산림 훼손 지역 자동 탐지</li>
                  <li>행정구역별 통계 정보 확인</li>
                  <li>불법 산지 전용지 등 이력관리</li>
                </ul>
              </li>
              <li>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => menuOnClickEvent('OCEAN')}
                >
                  <div
                    className={`mainMenuTit ${
                      userState.isLogin && userState.stae.OCEAN !== '승인' ? 'background_gray' : ''
                    }`}
                  >
                    <img
                      src={MainMenu4}
                      alt="해양쓰레기 관리 서비스"
                    />
                    <div>해양쓰레기 관리 서비스</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>해양쓰레기 자동 탐지</li>
                  <li>행정구역별 통계 정보 확인</li>
                  <li>행정구역별 쓰레기 수거량 지도 가시화</li>
                </ul>
              </li>
            </ul>

            {/* 무단방치차량은 항상 표시 */}
            <ul
              className={`mainMenuList ${
                (userState.userService.CROPS === 'MANAGER' && userState.stae.CROPS === '승인') ||
                (userState.userService.FORST === 'MANAGER' && userState.stae.FORST === '승인') ||
                (userState.userService.OCEAN === 'MANAGER' && userState.stae.OCEAN === '승인') ||
                (userState.userService.VEHICLE === 'MANAGER' && userState.stae.VEHICLE === '승인')
                  ? 'hide'
                  : ''
              }`}
            >
              <li style={{ maxWidth: '33.4%' }}>
                <a
                  onClick={() => menuOnClickEvent('VEHICLE')}
                  style={{ cursor: 'pointer' }}
                >
                  <div
                    className={`mainMenuTit ${
                      userState.isLogin && userState.stae.VEHICLE !== '승인' ? 'background_gray' : ''
                    }`}
                  >
                    <img
                      src={MainMenu5}
                      alt="무단방치차량 관리 서비스"
                    />
                    <div>무단방치차량 관리 서비스</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>위성 영상을 활용한 방치차량 자동 탐지</li>
                  <li>행정구역별 방치차량 관리</li>
                  <li>행정구역별 방치차량 지도 가시화</li>
                </ul>
              </li>
            </ul>

            {/* 매니저 조건에 따라 영상관리와 플랫폼만 표시/숨김 */}
            <ul
              className={`mainMenuList ${
                (userState.userService.CROPS === 'MANAGER' && userState.stae.CROPS === '승인') ||
                (userState.userService.FORST === 'MANAGER' && userState.stae.FORST === '승인') ||
                (userState.userService.OCEAN === 'MANAGER' && userState.stae.OCEAN === '승인') ||
                (userState.userService.VEHICLE === 'MANAGER' && userState.stae.VEHICLE === '승인')
                  ? ''
                  : 'hide'
              }`}
            >
              <li style={{ maxWidth: '33.4%' }}>
                <a
                  onClick={() => menuOnClickEvent('VEHICLE')}
                  style={{ cursor: 'pointer' }}
                >
                  <div
                    className={`mainMenuTit ${
                      userState.isLogin && userState.stae.VEHICLE !== '승인' ? 'background_gray' : ''
                    }`}
                  >
                    <img
                      src={MainMenu5}
                      alt="무단방치차량 관리 서비스"
                    />
                    <div>무단방치차량 관리 서비스</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>위성 영상을 활용한 방치차량 자동 탐지</li>
                  <li>행정구역별 방치차량 관리</li>
                  <li>행정구역별 방치차량 지도 가시화</li>
                </ul>
              </li>
              <li>
                <a href={service.img_path}>
                  <div className="mainMenuTit">
                    <img
                      src={MainMenu0}
                      alt="영상관리 서비스"
                    />
                    <div>영상관리 서비스</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>드론, 위성, 항공 영상정보 수집</li>
                  <li>영상정보 관리</li>
                </ul>
              </li>
              <li>
                <a href={service.pfm_path}>
                  <div className="mainMenuTit">
                    <img
                      src={MainMenu1}
                      alt="GEO AI Platform"
                    />
                    <div>GEO AI Platform</div>
                  </div>
                </a>
                <ul className="mainMenuCon">
                  <li>학습데이터 구축, 관리</li>
                  <li>AI 학습 및 적용</li>
                </ul>
              </li>
            </ul>
          </article>
          <FooterWrap />
        </section>
      </div>

      {/* 사용권한 없음 , 반려 start */}
      <div className="lWrap">
        <div className={modalIs ? 'lArea confirmLayer on' : 'lArea confirmLayer'}>
          <ServiceModal
            serviceId={serviceId}
            status={status}
            closeServiceModal={closeServiceModal}
            fetchUserData={fetchUserData}
          />
        </div>
        {/* 사용권한 없음 , 반려 end */}
      </div>
    </>
  );
}

export default MainPage;
